import React from 'react';
import styled from 'styled-components';
import {
    Box,
    InfoOutlined,
    InfoFilled,
    palette,
    Popover,
    useBreakpoint,
    ColorMode,
    spacing,
    ConditionalWrapper,
    IconSizes,
} from '@landr/maestro';

const Outlined = styled(InfoOutlined)`
    color: ${palette('neutral.400')};
`;

const Filled = styled(InfoFilled)`
    color: ${palette('neutral.400')};
`;

const InlineWrapper = styled(Box)`
    display: inline-block;
    vertical-align: middle;
    margin-left: ${spacing('xs')};
`;

const InfoPopover = ({
    isInverted = true,
    isOutlined = true,
    size,
    children,
}: {
    isInverted?: boolean;
    isOutlined?: boolean;
    size?: IconSizes;
    children: React.ReactNode;
}) => {
    const isMobile = useBreakpoint('md');

    return (
        <InlineWrapper>
            <ConditionalWrapper
                condition={isInverted}
                wrapper={(children: React.ReactNode): React.ReactNode => (
                    <ColorMode mode="invert">{children}</ColorMode>
                )}
            >
                <Popover
                    triggerEvent={isMobile ? 'click' : 'hover'}
                    placement="top"
                >
                    <Popover.Trigger>
                        <Box>
                            {isOutlined ? (
                                <Outlined size={size} />
                            ) : (
                                <Filled size={size} />
                            )}
                        </Box>
                    </Popover.Trigger>
                    <Popover.Content maxWidth={isMobile ? undefined : '320px'}>
                        {children}
                    </Popover.Content>
                </Popover>
            </ConditionalWrapper>
        </InlineWrapper>
    );
};

export default InfoPopover;
